import {BaseQueryArg, createApi, EndpointBuilder, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import {queries} from "../../Infrastructure/const/queries";


export const fileAPI = createApi({
    reducerPath: 'fileAPI',
    baseQuery: fetchBaseQuery({
        baseUrl: queries.baseURL,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('userToken');

            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
        }
    }),


    endpoints: (build) => ({
        fetchSentFiles: build.query ({
            query: () => ({
                url: 'files/sent',
                method: 'GET',
            })
        }),

        fetchReceivedFiles: build.query ({
            query: () => ({
                url: 'files/received',
                method: 'GET',
            })
        }),

        downloadFiles: build.query<Blob, number>({
            query: (id) => ({
                url: `files/download/${id}`,
                method: 'GET',
                responseHandler: async (response) => {
                    return response.blob(); // получаем бинарные данные
                },
            }),
        }),
    })

})